import { useEffect, useState } from 'react';
import { listJobTypes } from '../../reference-data/reference-data.api';

export interface JobTypeOption {
  value: string;
  label: string;
}

/** The queue's job-type filter: a small fixed catalogue, fetched whole. A failed fetch leaves the filter empty rather than blocking the queue. */
export function useJobTypeOptions(): JobTypeOption[] {
  const [options, setOptions] = useState<JobTypeOption[]>([]);

  useEffect(() => {
    let cancelled = false;
    listJobTypes()
      .then((jobTypes) => {
        if (!cancelled) setOptions(jobTypes.filter((type) => type.isActive).map((type) => ({ value: type.code, label: type.name })));
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return options;
}
